import script from "./RecommendationResults.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommendationResults.vue?vue&type=script&setup=true&lang=js"

import "./RecommendationResults.vue?vue&type=style&index=0&id=47171df6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47171df6"]])

export default __exports__